import { useContext } from "react";
import { GameState } from "../GameState";
import MainMenuButton from "./MainMenuButton";

const Instructions = () => {
  const state = useContext(GameState);

  return (
    <div className="instructions">
      <div className="instructionline">
        The worst has come to pass: The IRS is cracking down on your vast
        criminal empire!
      </div>

      <div className="instructionline">
        Your task is to launder as much of your incoming revenue as possible
        before the tax man shuts down all your operations.
      </div>

      <div className="instructionline">
        Transfer money between your offshore accounts by clicking a city and
        selecting "TRANSFER". Watch out, the agents can intercept your
        transfers!
      </div>

      <div className="instructionline">
        You can also upgrade each operation's money laundering rate by selecting
        "UPGRADES". You can only buy upgrades for an operation with the money it
        has on hand.
      </div>

      <div className="instructionline">
        If you draw too much attention to an operation, the agents may raid it
        and possibly shut it down.
      </div>

      <div className="instructionline">
        The game is over when all of your operations have been shut down.
      </div>
      <MainMenuButton name={"GO BACK"} action={() => state.setGameMode(0)} />
    </div>
  );
};

export default Instructions;
